import { Tooltip } from '@fiverr-private/tooltip';

export default Tooltip;
